import { MessageCircle } from "lucide-react";
import { useSiteContent } from "@/lib/useSiteContent";

export default function WhatsAppFloat() {
  const url = useSiteContent().whatsapp_float?.url || "https://wa.me/+971586124320";
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 flex items-center justify-center bg-[#1D1D1F] hover:bg-[#B68D40] text-white transition-colors duration-500 shadow-[0_10px_30px_rgba(0,0,0,0.25)] rounded-full"
    >
      <MessageCircle size={22} strokeWidth={1.3} />
    </a>
  );
}
